export default "__VITE_ASSET__C6U5uFVY__"